import { api } from "../../index";
import { ASSETS_ACTIONS } from "./constants";
import { propValueOr } from "../../helpers/common";

export const fetchAssetsAction = filter => async dispatch => {
  dispatch({
    type: ASSETS_ACTIONS.fetch.request
  });
  dispatch({
    type: ASSETS_ACTIONS.reset
  });
  return api.assets
    .list(filter)
    .then(resp => {
      const assets = propValueOr(resp, "data", []);

      dispatch({
        type: ASSETS_ACTIONS.fetch.success,
        payload: assets
      });
    })
    .catch(err => {
      dispatch({ type: ASSETS_ACTIONS.fetch.error, payload: err });
    });
};
